import React, { Component } from "react";
import PropTypes from "prop-types";
import "./specialColumnList.css";
import "antd/dist/antd.css";
// import Editor from "./editor";
import { Row, Col, Checkbox, Modal } from "antd";
import ViewSpecialColumn from "./ViewSpecialColumn";

export default class SpecialColumnList extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#1E9FFF",
  };
  // 静态类型分析
  static propTypes = {
    storagePicture: PropTypes.string.isRequired, //图片
    showPicture: PropTypes.string.isRequired, //图片
    name: PropTypes.string.isRequired, //全称
    shortName: PropTypes.string.isRequired, //简称
    status: PropTypes.string.isRequired, //状态
    enabled: PropTypes.string.isRequired, //授权
    top: PropTypes.bool.isRequired, //置顶
    createDate: PropTypes.string.isRequired, //创建时间
    updateDate: PropTypes.string.isRequired, //更新时间
    id: PropTypes.string.isRequired, //id
  };
  constructor(props) {
    super(props);
    this.state = {
      visible1: false,
      visible3: false,
      visible4: false,
    };
  }
  // 编辑专题
  editST() {
    // console.log("edit!");
    // console.log(data);
    let layer
    var id = this.props.id;
    var url = "/cm-sites/pms/mediaFusion/specialTopicEdit.html?id=" + id;
    layer.open({
      title: "编辑专题",
      type: 2,
      content: url,
      area: ["800px", "500px"],
      resize: true,
    });
  }
  // 点击编辑拿到子组件的方法
  showModal2 = () => {
    // this.props.getClickEditId(this.props.id);
    // this.refs.editor.showModal();
    this.editST();
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible1: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible1: false,
    });
  };
  view = () => {
    this.refs.viewSpecialColumn.showModal();
  };

  showModal3 = () => {
    this.setState({
      visible3: true,
    });
  };

  handleOk3 = (e) => {
    console.log(e);
    this.setState({
      visible3: false,
    });
  };

  handleCancel3 = (e) => {
    console.log(e);
    this.setState({
      visible3: false,
    });
  };
  // 删除确认框
  showModal4 = () => {
    this.setState({
      visible4: true,
    });
  };

  handleOk4 = (e) => {
    this.props.delete(this.props.id);
    console.log(e);
    this.setState({
      visible4: false,
    });
  };

  handleCancel4 = (e) => {
    console.log(e);
    this.setState({
      visible4: false,
    });
  };
  render() {
    // props放在state中只渲染一次
    let top = this.props.top;
    let enabled = this.props.enabled;
    let isTop;
    let topStyle;
    if (top) {
      topStyle = (
        <div
          style={{
            margin: "0px 20px",
            color: this.props.newSecondSelectColor,
            border: "1px " + this.props.newSecondSelectColor + " solid",
            width: "35px",
            height: "18px",
            textAlign: "center",
            lineHeight: "18px",
          }}
        >
          置顶
        </div>
      );
    } else {
      topStyle = (
        <div
          style={{
            margin: "10px 35px",
            color: this.props.newSecondSelectColor,
            border: "1px " + this.props.newSecondSelectColor + " solid",
            backgroundColor: this.props.newSecondSelectColor,
            width: "5px",
            height: "5px",
          }}
        />
      );
    }

    if (top && enabled) {
      isTop = (
        <div
          style={{ color: "red" }}
          onClick={() => this.props.getSpecialColumnListId(this.props.id)}
        >
          取消置顶
        </div>
      );
    } else if (enabled && !top) {
      isTop = (
        <div
          style={{ color: "red" }}
          onClick={() => this.props.getSpecialColumnListId(this.props.id)}
        >
          置顶
        </div>
      );
    }
    if (!enabled) {
      isTop = (
        <div style={{ color: "red" }} onClick={this.showModal4}>
          删除
        </div>
      );
    }
    return (
      <div
        style={{
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #ccc",
            padding: "5px",
            marginTop: "5px",
          }}
        >
          <Row
            justify="start"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col
              span={11}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Checkbox
                checked={this.props.checked} //拿到父组件内部子组件的checked方法
                onClick={(e) => {
                  this.props.ItemClick(); //点击子组件时拿到父组件内部子组件的方法
                }}
              />
              <div
                className="atlasListPic"
                style={{ marginLeft: "20px" }}
                onClick={this.view}
              >
                <img src={this.props.storagePicture} alt="" />
              </div>
              <div style={{ display: "flex" }} onClick={this.view}>
                {topStyle}
                <div className="mf-title">{this.props.name}</div>
              </div>
            </Col>
            <ViewSpecialColumn
              ref="viewSpecialColumn"
              storagePicture={this.props.storagePicture}
              name={this.props.name}
              shortName={this.props.shortName}
              enabled={this.props.enabled}
            />
            <Col span={3} style={{ textAlign: "center" }}>
              {this.state.enabled === false ? "禁用" : "启用"}
            </Col>
            <Col span={3} style={{ textAlign: "center" }}>
              {this.props.createDate}
            </Col>
            <Col span={3} style={{ textAlign: "center" }}>
              {this.props.updateDate}
            </Col>
            <Col span={4} style={{ textAlign: "center", cursor: "pointer" }}>
              <div
                style={{
                  color: `${this.props.newSecondSelectColor}`,
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
                onClick={this.showModal2}
              >
                编辑
              </div>
              {/* 编辑组件 */}
              <ViewSpecialColumn
                ref="viewSpecialColumn"
                ref="editor"
                storagePicture={this.props.storagePicture}
                showPicture={this.props.showPicture}
                name={this.props.name}
                shortName={this.props.shortName}
                enabled={this.props.enabled}
                top={this.props.top}
                myAlter={(txtText) => this.alter(txtText)}
                myAlter2={(txtText2) => this.alter2(txtText2)}
                getEditStore={(obj) => this.props.getEditStore(obj)}
                createDate={this.props.createDate}
                updateDate={this.props.updateDate}
                id={this.props.id}
              />
              {isTop}
            </Col>
            {/* 删除确认框 */}
            <Modal
              title="信息提示"
              visible={this.state.visible4}
              onOk={this.handleOk4}
              onCancel={this.handleCancel4}
            >
              确定删除该专题吗？一旦删除不可恢复！
            </Modal>
          </Row>
        </div>
      </div>
    );
  }
  //  修改全称
  alter(txtText) {
    this.setState({
      name: txtText,
    });
  }
  alter2(txtText2) {
    this.setState({
      shortName: txtText2,
    });
  }
}
